import navPanel from '../../components/nav-panel/nav-panel';
import navMobile from '../../components/nav-mobile/nav-mobile';
import topBar from '../../components/top-bar/top-bar';
import laskurit from '../../blocks/laskurit/laskurit';
import { init, popup } from '../../blocks/karuselli/karuselli';
import startMasonry from '../../blocks/gallery/gallery';

const appStart = () => {
  navPanel();
  navMobile();
  topBar();
  laskurit();
  init();
  popup();
  // template();
  startMasonry();
};

// 'DOMContentLoaded' may fire before your script has a chance to run.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', appStart);
} else {
  appStart();
}
